module.exports = __webpack_public_path__ + "static/media/563263_10151447185909316_633258444_n.332eb9f7.jpg";